import { render } from "./selecdCoupon.vue?vue&type=template&id=4ca6eb1b&scoped=true"
import script from "./selecdCoupon.vue?vue&type=script&lang=js"
export * from "./selecdCoupon.vue?vue&type=script&lang=js"

import "./selecdCoupon.vue?vue&type=style&index=0&id=4ca6eb1b&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca6eb1b"]])

export default __exports__